import React
    , {} from "react";
import useRepeatables
    from "../../../hooks/useRepeatables";
import {Button} from "@mui/material";
import {
    AddOutlined,
    KeyboardArrowRightOutlined
} from "@mui/icons-material";

const FormRow = ({
                     template,
                     defaultAnswer,
                     subheaderRow = 0
                 }) => {
    const {
        addRow,
        childElements,
        rows
    } = useRepeatables({
        template,
        defaultAnswer,
        subheaderRow,
        type: 'row',
        showAddButton: false,
        defaultRows: 1
    });

    return <div className='fz-form-field-group'>
        <fieldset>
            <legend className="fz-form-legend fz-form-row-legend">{template.content.value}</legend>
            {childElements()}
            {template.content?.disableNewRow !== true && (
                <div className="fz-form-repeatable-buttons">
                    <Button variant="contained" color="neutral" startIcon={<AddOutlined />} className='fz-form-button fz-form-repeatable-button fz-form-repeatable-add-button fz-form-element-row-button' onClick={addRow}>Add Row</Button>
                </div>
            )}
        </fieldset>
    </div>;
}

export default FormRow;